import { render, staticRenderFns } from "./ContactIcon.vue?vue&type=template&id=0ab538bd"
import script from "./ContactIcon.vue?vue&type=script&lang=js"
export * from "./ContactIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports